/* eslint-disable no-unused-expressions */

import { InputAdornment, Slider, SliderThumb, TextField } from '@mui/material';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { isNumber } from './helpers';

const slider = '/-/media/Project/FAB2/shared/images/icon_slider-indicator.svg';
const deleteIcon = '/-/jssmedia/Project/FAB2/shared/images/ico_closeCircle-blue.svg';

const CustomSliderThumb = (props) => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <img src={slider} alt="slider" />
    </SliderThumb>
  );
};
// A reusable component used to output sliders and text fields
// if inputs is true -> life style calculator, we need to add fields and remove fields as per the user needs
const SingleInput = ({
  label,
  subLabel,
  min,
  max,
  maxLength,
  placeholder,
  adornment,
  step,
  value,
  setValue,
  index,
  inputs,
  setInputs,
  numbersOnly = false,
  withDelete = false,
  withDecimal = false,
}) => {
  const shouldRenderLabel = !!label?.value;
  const shouldRenderSubLabel = !!subLabel?.value;
  const shouldRenderMin = !!min?.value;
  const shouldRenderMax = !!max?.value;
  const shouldRenderMaxLength = !!maxLength?.value;
  const shouldRenderStep = !!step?.value;
  const shouldRenderPlaceholder = !!placeholder?.value;
  const shouldRenderAdornment = !!adornment?.value;

  const marks = [
    {
      value: min?.value,
      label: min?.value?.toLocaleString(),
    },
    {
      value: max?.value,
      label: max?.value?.toLocaleString(),
    },
  ];

  let inputValue = '';
  if (!inputs) {
    inputValue = value;
  } else {
    inputs.map((item, inputIndex) => {
      if (index === inputIndex) {
        inputValue = item?.inputValue;
      }
    });
  }

  const inputsCB = (valParam) => (prev) => {
    let arr = [];
    prev.map((item, inputIndex) => {
      if (index === inputIndex) {
        arr.push({
          ...item,
          inputValue: valParam,
        });
      } else {
        arr.push(item);
      }
    });
    return arr;
  };

  const removeInput = (index) => {
    setInputs((prev) => prev.filter((_, itemIndex) => index !== itemIndex));
  };

  return (
    <div className="input-container">
      {shouldRenderLabel && (
        <div className="input-label">
          <Text field={label} />
        </div>
      )}
      {shouldRenderSubLabel && <RichText className="input-sub-label" field={subLabel} />}
      <div className="input-content">
        <Slider
          className="input-content-slider d-none d-xl-block"
          value={typeof inputValue === 'number' ? inputValue : min?.value}
          onChange={(e) => {
            if (!inputs) {
              setValue(e?.target?.value);
            } else {
              setInputs(inputsCB(e?.target?.value));
            }
          }}
          min={min?.value}
          max={max?.value}
          step={shouldRenderStep ? step?.value : 1}
          marks={marks}
          components={{ Thumb: CustomSliderThumb }}
        />
        {shouldRenderPlaceholder && (
          <TextField
            className="input-content-field"
            label={placeholder?.value}
            type="tel"
            onBlur={() => {
              if (!isNumber(inputValue) || inputValue < min?.value) {
                if (!inputs) {
                  setValue(min?.value);
                } else {
                  setInputs(inputsCB(min?.value));
                }
              }
            }}
            value={typeof inputValue !== 'number' ? inputValue : inputValue?.toLocaleString()}
            onChange={(e) => {
              let input = e?.target?.value;
              if (!withDecimal) {
                input = input?.replace(/\D/g, '');
              }
              const onlyNumbersAndOneDot = /^[0-9]*\.?[0-9]*$/;
              const onlyNumbers = /^\d*$/;
              if (!inputs) {
                if (numbersOnly && !onlyNumbers?.test(input)) {
                  return;
                }
                if (!onlyNumbersAndOneDot?.test(input)) {
                  return;
                }
                if (input?.endsWith('.')) {
                  setValue(e.target.value);
                  return;
                }
                if (input === '') {
                  setValue(input);
                  return;
                }
                const parsedInput = parseFloat(input);
                if (parsedInput > max?.value) {
                  setValue(max?.value);
                  return;
                }
                setValue(parsedInput);
              } else {
                if (numbersOnly && !onlyNumbers.test(input)) {
                  return;
                }
                if (!onlyNumbersAndOneDot.test(input)) {
                  return;
                }
                if (input?.endsWith('.')) {
                  setInputs(inputsCB(e?.target?.value));
                  return;
                }
                if (input === '') {
                  setInputs(inputsCB(input));
                  return;
                }
                const parsedInput = parseFloat(input);
                if (parsedInput > max?.value) {
                  setInputs(inputsCB(max?.value));
                  return;
                }
                setInputs(inputsCB(parsedInput));
              }
            }}
            inputProps={
              !shouldRenderMaxLength || !shouldRenderMax || shouldRenderMin
                ? {}
                : { maxLength: maxLength?.value, max: max?.value, min: min?.value }
            }
            InputProps={
              !shouldRenderAdornment
                ? {}
                : {
                    startAdornment: (
                      <InputAdornment position="start">{adornment?.value}</InputAdornment>
                    ),
                  }
            }
          />
        )}
        {withDelete && (
          <button onClick={() => removeInput(index)} className="delete-btn">
            <img src={deleteIcon} alt="delete" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SingleInput;
